import { PropsWithChildren } from "react";
import clsx from "clsx";

export const FormRow = ({
  top = "small",
  gap = "small",
  isRow = false,
  isBetween = false,
  className = "",
  children,
}: {
  top?: "small" | "medium" | "large" | "none";
  gap?: "small" | "medium" | "large";
  isRow?: boolean;
  isBetween?: boolean;
  className?: string;
} & PropsWithChildren) => {
  let topStyles;
  switch (top) {
    case "none":
      topStyles = "pt-0";
      break;
    case "small":
      topStyles = "pt-6";
      break;
    case "medium":
      topStyles = "pt-8";
      break;
    case "large":
    default:
      topStyles = "pt-10";
  }

  let gapStyles;
  switch (gap) {
    case "small":
      gapStyles = "gap-6";
      break;
    case "medium":
      gapStyles = "gap-8";
      break;
    case "large":
    default:
      gapStyles = "gap-10";
  }

  return (
    <div
      className={clsx(
        "flex",
        isRow ? "flex-row" : "flex-col",
        isBetween ? "justify-between" : "",
        topStyles,
        gapStyles,
        className,
      )}
    >
      {children}
    </div>
  );
};
